import React from "react";
import { BUTTON_RESET } from "../../styles";

export function Breadcrumb({ items, onHome }) {
  return (
    <div
      style={{
        display: "flex",
        gap: 6,
        marginTop: 14,
        flexWrap: "wrap",
        alignItems: "center",
        marginBottom: 14,
      }}
    >
      <button
        onClick={onHome}
        style={{
          ...BUTTON_RESET,
          background: "rgba(255,255,255,.08)",
          color: "rgba(255,255,255,.72)",
          borderRadius: 999,
          padding: "4px 10px",
          fontSize: 11,
          fontWeight: 700,
        }}
      >
        Cursos
      </button>
      {items.map((item, index) => {
        const active = index === items.length - 1;
        return (
          <React.Fragment key={`${item.label}-${index}`}>
            <span style={{ color: "rgba(255,255,255,.28)", fontSize: 10 }}>
              {">"}
            </span>
            {active ? (
              <span
                style={{
                  background: "rgba(79,179,169,.16)",
                  color: "#D7FBF5",
                  borderRadius: 999,
                  padding: "4px 10px",
                  fontSize: 11,
                  fontWeight: 800,
                }}
              >
                {item.label}
              </span>
            ) : (
              <button
                onClick={item.onClick}
                style={{
                  ...BUTTON_RESET,
                  background: "rgba(255,255,255,.08)",
                  color: "rgba(255,255,255,.68)",
                  borderRadius: 999,
                  padding: "4px 10px",
                  fontSize: 11,
                  fontWeight: 700,
                }}
              >
                {item.label}
              </button>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
